import { render, staticRenderFns } from "./analysis.vue?vue&type=template&id=4b6c57a3&scoped=true"
import script from "./analysis.vue?vue&type=script&lang=js"
export * from "./analysis.vue?vue&type=script&lang=js"
import style0 from "./analysis.vue?vue&type=style&index=0&id=4b6c57a3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6c57a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b6c57a3')) {
      api.createRecord('4b6c57a3', component.options)
    } else {
      api.reload('4b6c57a3', component.options)
    }
    module.hot.accept("./analysis.vue?vue&type=template&id=4b6c57a3&scoped=true", function () {
      api.rerender('4b6c57a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/boardManage/board/analysis.vue"
export default component.exports